<div class="close" (click)="close()">{{ 'NGX-MESSAGING.close' | translate }}</div>
@if (!isLoading()) { @if (canProffesionalize && translaterService.verifyCanTranslateWithLocalSetting) {
<div class="modal-tab">
  <div class="modal-tab__translation" [ngClass]="{ 'modal-tab__selected': !originalTab() }" (click)="selectTranslation()">
    {{ 'NGX-MESSAGING.TRANSLATER.translation' | translate }}
  </div>
  <div class="modal-tab__original" [ngClass]="{ 'modal-tab__selected': originalTab() }" (click)="selectOriginal()">
    {{ 'NGX-MESSAGING.TRANSLATER.original' | translate }}
  </div>
</div>
}

<div class="modal-content" mat-dialog-content>
  <div class="modal-content__message">
    <h3>{{ 'NGX-MESSAGING.PROFESSIONALIZER.original' | translate }}</h3>
    <p>{{ original() }}</p>
  </div>
  <div class="modal-content__message modal-content__separator">
    <h3>{{ 'NGX-MESSAGING.PROFESSIONALIZER.suggested' | translate }}</h3>
    <p>{{ suggested() }}</p>
  </div>
</div>
<div class="modal-actions" mat-dialog-actions>
  <button mat-stroked-button color="primary" (click)="sendResponse(original())">
    {{ 'NGX-MESSAGING.PROFESSIONALIZER.sendOriginal' | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    id="professionalizeButton"
    class="btn-principal"
    (click)="sendResponse(suggested(), true)">
    <mat-icon svgIcon="send"></mat-icon>
    {{ 'NGX-MESSAGING.PROFESSIONALIZER.sendSuggested' | translate }}
  </button>
</div>
} @else {
<div class="loading">
  <div>
    <p>{{ 'NGX-MESSAGING.PROFESSIONALIZER.hangTightWhileWeProfessionalizeYourMessage' | translate }}</p>
  </div>
</div>
}
